export default "__VITE_ASSET__BVmX6x$4__"